/**
 * Cascade print Size/Shape/Stock/… dropdowns from legal combo rows.
 * Payload: combo_keys + combos on [data-ezink-print-combo-json].
 */
(function () {
  function parsePayload(root) {
    var node = root.querySelector("[data-ezink-print-combo-json]");
    if (!node) return null;
    try {
      return JSON.parse(node.textContent || "{}");
    } catch (err) {
      return null;
    }
  }

  function fieldWrap(select) {
    return select.closest(".ezink-print-field") || select.parentElement;
  }

  function isHiddenPrintValue(v) {
    var t = String(v || "").trim().toLowerCase();
    if (!t) return false;
    if (t.indexOf("velcro") !== -1) return true;
    if (t === "rope" || t.indexOf("sewn rope") === 0 || t.indexOf("rope ") === 0) return true;
    if (t.indexOf("d-ring") !== -1 || t.indexOf("d ring") !== -1 || t.indexOf("webbing") !== -1) return true;
    return false;
  }

  function meaningful(key, vals) {
    var out = [];
    for (var i = 0; i < vals.length; i++) {
      var v = vals[i];
      if (!v) continue;
      if (isHiddenPrintValue(v)) continue;
      if (key === "Spot UV sides" && v === "No Spot UV") continue;
      out.push(v);
    }
    return out;
  }

  function uniqueAt(combos, idx) {
    var seen = {};
    var out = [];
    for (var i = 0; i < combos.length; i++) {
      var v = combos[i][idx] || "";
      if (!v || seen[v] || isHiddenPrintValue(v)) continue;
      seen[v] = 1;
      out.push(v);
    }
    return out;
  }

  function orderedVals(payload, key, vals) {
    var order = [];
    if (key === "Size") order = payload.options || [];
    else {
      var specs = payload.specs || [];
      for (var i = 0; i < specs.length; i++) {
        if (specs[i].name === key) {
          order = specs[i].options || [];
          break;
        }
      }
    }
    var set = {};
    for (var v = 0; v < vals.length; v++) set[vals[v]] = 1;
    var out = [];
    for (var o = 0; o < order.length; o++) {
      if (set[order[o]]) out.push(order[o]);
    }
    for (var j = 0; j < vals.length; j++) {
      if (out.indexOf(vals[j]) === -1) out.push(vals[j]);
    }
    return out;
  }

  function normCombo(key, v) {
    v = String(v || "").replace(/\s+/g, " ").trim();
    var t = v.toLowerCase();
    if (key === "Drill Hole") {
      if (!t || t.indexOf("no hole") !== -1 || t.indexOf("no drill") !== -1) return "";
    }
    if (key === "Folding Options") {
      if (!t || t.indexOf("no fold") !== -1 || t.indexOf("flat") === 0) return "";
    }
    return v;
  }

  function matching(combos, keys, values, upTo) {
    var out = [];
    for (var r = 0; r < combos.length; r++) {
      var row = combos[r];
      var ok = true;
      for (var i = 0; i < upTo; i++) {
        var want = values[keys[i]];
        if (want === undefined || want === null) continue;
        if (normCombo(keys[i], row[i] || "") !== normCombo(keys[i], want)) {
          ok = false;
          break;
        }
      }
      if (ok) out.push(row);
    }
    return out;
  }

  function refill(select, vals, keep) {
    var current = keep || select.value || "";
    select.innerHTML = "";
    for (var i = 0; i < vals.length; i++) {
      var opt = document.createElement("option");
      opt.value = vals[i];
      opt.textContent = vals[i];
      if (vals[i] === current) opt.selected = true;
      select.appendChild(opt);
    }
    if (vals.indexOf(current) !== -1) {
      select.value = current;
    } else if (vals.length) {
      select.value = vals[0];
    } else {
      select.value = "";
    }
  }

  function initRoot(root) {
    if (root.getAttribute("data-ezink-print-combo-ready") === "1") return;
    var payload = parsePayload(root);
    var keys = payload && payload.combo_keys;
    var combos = payload && payload.combos;
    if (!keys || !combos || !combos.length) return;
    root.setAttribute("data-ezink-print-combo-ready", "1");

    var selects = {};
    root.querySelectorAll("[data-ezink-print-key]").forEach(function (sel) {
      selects[sel.getAttribute("data-ezink-print-key")] = sel;
    });
    var keyIndex = {};
    keys.forEach(function (k, i) {
      keyIndex[k] = i;
    });

    var applying = false;

    function currentValues() {
      var values = {};
      keys.forEach(function (k) {
        var sel = selects[k];
        var wrap = sel && fieldWrap(sel);
        if (!sel || (wrap && wrap.classList.contains("is-combo-hidden"))) {
          values[k] = "";
        } else {
          values[k] = sel.value || "";
        }
      });
      return values;
    }

    function applyFrom(start) {
      if (applying) return;
      applying = true;
      var changedPrintOpt = false;
      try {
        var values = currentValues();
        for (var i = start; i < keys.length; i++) {
          var key = keys[i];
          var sel = selects[key];
          if (!sel) continue;
          var rows = matching(combos, keys, values, i);
          var vals = orderedVals(payload, key, uniqueAt(rows, keyIndex[key]));
          var show = meaningful(key, vals).length > 0;
          if (key === "Spot UV sides" && show && vals.indexOf("No Spot UV") !== -1) {
            vals = ["No Spot UV"].concat(vals.filter(function (v) { return v !== "No Spot UV"; }));
          }
          var wrap = fieldWrap(sel);
          if (!show) {
            if (wrap) wrap.classList.add("is-combo-hidden");
            sel.disabled = true;
            sel.removeAttribute("required");
            sel.value = "";
            values[key] = "";
            continue;
          }
          if (wrap) wrap.classList.remove("is-combo-hidden");
          sel.disabled = false;
          refill(sel, vals, values[key]);
          values[key] = sel.value || "";
          if (sel.getAttribute("data-ezink-print-opt")) changedPrintOpt = true;
        }
        if (changedPrintOpt) {
          var opt = root.querySelector("[data-ezink-print-opt]");
          if (opt) opt.dispatchEvent(new Event("change", { bubbles: true }));
        }
      } finally {
        applying = false;
        var ev = new Event("ezink-print-combo", { bubbles: true });
        root.dispatchEvent(ev);
        document.dispatchEvent(new Event("ezink-print-combo"));
      }
    }

    keys.forEach(function (key, idx) {
      var sel = selects[key];
      if (!sel) return;
      sel.addEventListener("change", function () {
        if (applying) return;
        applyFrom(idx + 1);
      });
    });

    applyFrom(0);
  }

  function boot() {
    document.querySelectorAll("[data-ezink-print-size]").forEach(initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", boot);
  } else {
    boot();
  }
})();
